export const ADD_QUESTION_TEMPORARY = 'QUESTION_TEMPORARY';
export const NO_PUBLIC_QUESTION = 'MFS-E-LEARNING-ADMIN-LESSON-UNIT-64';
export const NO_PUBLIC_UNIT = 'MFS-E-LEARNING-ADMIN-LESSON-UNIT-66';
